import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CartaCreateDishProdSelectPage } from '../carta-create-dish-prod-select/carta-create-dish-prod-select';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the MenuCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-create-select-template',
  templateUrl: 'carta-create-select-template.html',
})
export class CartaCreateSelectTemplatePage {

  template: any = "";
  update_state: boolean = false;
  carta_uid: any;
  type: any = '';
  carta_name: any = '';
  template_array = [
    {
      name: 'typhoon',
      src: './assets/templates/typhoon.jpg'
    },
    {
      name: 'cota-25',
      src: './assets/templates/cota_25.jpg'
    },
    {
      name: 'aerox',
      src: './assets/templates/aerox.jpg'
    },
    {
      name: 'bultaco',
      src: './assets/templates/bultaco.jpg'
    },
    {
      name: 'cota',
      src: './assets/templates/cota.jpg'
    },
    {
      name: 'gladius',
      src: './assets/templates/gladius.jpg'
    },
    {
      name: 'scoopy',
      src: './assets/templates/scoopy.jpg'
    },
    {
      name: 't-max',
      src: './assets/templates/T-MAX.jpg'
    },
    {
      name: 'variant',
      src: './assets/templates/variant.jpg'
    },
    {
      name: 'jog',
      src: './assets/templates/jog.jpg'
    },
    {
      name: 'vespino',
      src: './assets/templates/vespino.jpg'
    },
    {
      name: 'vespa',
      src: './assets/templates/vespa.png'
    },
    {
      name: 'ossa',
      src: './assets/templates/ossa.jpg'
    },
    {
      name: 'puch',
      src: './assets/templates/Puch.jpg'
    },
    {
      name: 'p200',
      src: './assets/templates/P200.jpg'
    },
    {
      name: 'rd350',
      src: './assets/templates/RD350.jpg'
    },
    {
      name: 'cl150',
      src: './assets/templates/CL150.jpg'
    },
    {
      name: 'gs500',
      src: './assets/templates/GS500.jpg'
    },
    {
      name: 'ninja',
      src: './assets/templates/NINJA.jpg'
    },
    {
      name: 'primavera75',
      src: './assets/templates/primavera75.jpg'
    },
    {
      name: 'x-max',
      src: './assets/templates/x-max.jpg'
    },
    {
      name: 'xt600',
      src: './assets/templates/xt600.jpg'
    },
  ];
  new_carta: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public cartaServices: CartaServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.carta_uid = this.navParams.get('carta_uid');
    this.carta_name = this.navParams.get('carta_name');
    this.new_carta = this.navParams.get('new_carta');
    this.type = this.cartaServices.carta_tmp.template_name;

    if (!this.update_state) { //Si create y FREE
      this.type = 'typhoon';
    }

  }

  ionViewWillEnter() {
    if (this.globals.checkLimitsByLicense('menus', 'template') != -1) {
      this.changeClass();
    }
  }

  changeClass() {
    //Ponemos filtro gris a las plantillas que la version no puede usar
    const templates = document.getElementsByClassName('template');
    for (let i = this.globals.checkLimitsByLicense('menus', 'template'); i < templates.length; i++) {
      const slide = templates[i] as HTMLElement;
      slide.style.filter = "grayscale(1)";
    }
  }

  select(type) {
    switch (type) {
      case 'typhoon':
        this.type = type;
        break;
      case 'cota-25':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'aerox':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'bultaco':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'cota':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'gladius':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'scoopy':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 't-max':
        if (this.globals.checkLimitsByLicense('menus', 'template') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'variant':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'jog':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'vespino':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'vespa':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'ossa':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'puch':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'p200':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'rd350':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'cl150':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'gs500':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'ninja':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'primavera75':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'x-max':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'xt600':
        if (this.globals.checkLimitsByLicense('menus', 'template') != -1) { //Si FREE o PRO
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
    }
  }

  selected() {
    this.template = "";
  }

  checkState(type) {
    if (this.type == type) {
      return true
    } else {
      return false
    }
  }

  save() {
    //Comprovamos que haya seleccionado una plantilla
    if (this.type != '') {
      //Comprovamos si es una nueva carta o actualizacion
      if (this.update_state) {
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'template_name': this.type,
          'updated_at': new Date(),
        }).then(doc => {
          this.globals.GAtrackView('Cartas', 'Cartas - Select type - Update', this.globals.restaurant.email, 'Create/Update', 'Update select template', 'Cartas', this.carta_uid);
          this.navCtrl.pop();
        });
      } else {
        this.cartaServices.afs.collection('cartas').add({
          UID_RESTAURANT: this.globals.restaurant_uid,
          name: this.translate.instant('general-carta'),
          name_ca: this.translate.instant('general-carta'),
          name_en: this.translate.instant('general-carta'),
          name_it: this.translate.instant('general-carta'),
          name_fr: this.translate.instant('general-carta'),
          name_de: this.translate.instant('general-carta'),
          subtitle: '',
          template_name: this.type,
          created_at: new Date(),
          show_enumerate_elements: false,
          show_logo: true,
          show_caption: false,
          hide_footer: true,
          show_description: false,
          show_price: true,
          show_price_half: true,
          show_price_tapa: true,
          show_enumerate_pages: false,
          template: 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
          digital_app: true,
          order_share: 0,
        }).then(doc => {
          this.globals.GAtrackView('Cartas', 'Cartas - Select type - Create', this.globals.restaurant.email, 'Create/Update', 'Create select template', 'Cartas', doc.id);
          this.analyticsServices.trackingExp('starter', this.globals.tracking_exp['starter'], '');
          this.analyticsServices.trackingExp('crear carta', this.globals.tracking_exp['create_new_menu'], '');
          //push
          this.navCtrl.push(CartaCreateDishProdSelectPage, {
            type: this.type,
            carta_uid: doc.id,
            page_index: 0,
            section_index: 0,
            update_state: false,
            new_section: true,
            new_carta: this.new_carta
          });
        });
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-select-template/carta-create-select-template.ts